// Operations: the Operations Dashboard (OPS_DASHBOARD_URL, a tailnet-only service) inside the admin.
// A browser won't frame a plain-HTTP page inside this HTTPS app, so that case gets a link instead.
import { useState } from 'react';
import { ExternalLink, RotateCw } from 'lucide-react';
import { config } from '../lib/config';
import { Banner, ButtonA, Button, Card } from '../ui';

export function OperationsPage() {
  const url = config().opsDashboardUrl;
  const [key, setKey] = useState(0);
  const blocked = window.location.protocol === 'https:' && url.startsWith('http:');
  return (
    <div className="flex w-full flex-col gap-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5">
          <h1 className="page-title">Operations</h1>
          <p className="m-0 text-[13px] text-muted">The Operations Dashboard. You need to be on Tailscale to see it.</p>
        </div>
        <div className="flex gap-2">
          {!blocked && <Button size="sm" onClick={() => setKey((k) => k + 1)}><RotateCw aria-hidden size={14} /> Reload</Button>}
          <ButtonA size="sm" href={url} target="_blank" rel="noreferrer"><ExternalLink aria-hidden size={14} /> Open in a new tab</ButtonA>
        </div>
      </div>
      {blocked ? (
        <Card className="flex flex-col items-start gap-3 p-6">
          <Banner tone="warn">
            Your browser won’t show the dashboard inside the Platform: the dashboard is plain HTTP and the Platform is HTTPS.
          </Banner>
          <p className="m-0 text-sm text-ink-2">Open it in a new tab for now. To show it here, serve the dashboard over HTTPS on the tailnet and point <code className="rounded bg-subtle px-1">OPS_DASHBOARD_URL</code> at the HTTPS address.</p>
          <ButtonA variant="primary" href={url} target="_blank" rel="noreferrer"><ExternalLink aria-hidden size={16} /> Open the Operations Dashboard</ButtonA>
        </Card>
      ) : (
        <iframe key={key} src={url} title="Operations Dashboard" referrerPolicy="no-referrer"
          className="h-[calc(100vh-150px)] min-h-[520px] w-full rounded-card border border-line bg-white" />
      )}
    </div>
  );
}
